<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
        <div class="row">
          <app-form-group label="Terminal name">
            <input [(ngModel)]="exemption.terminalName" id="terminalName" type="text"
                   maxlength="128" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Contact person">
            <input [(ngModel)]="exemption.contactPerson" id="contactPerson" type="text"
                   maxlength="128" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Address terminal">
            <input [(ngModel)]="exemption.addressTerminal" id="addressTerminal" type="text"
                   maxlength="128" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="E-mail address of contact person">
            <input [(ngModel)]="exemption.emailContactPerson" id="emailContactPerson" type="text"
                   maxlength="128" class="form-control">
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name director">
            <input [(ngModel)]="exemption.directorName" id="directorName" type="text"
                   maxlength="128" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Accountable person from terminal">
            <input [(ngModel)]="exemption.accountablePerson" id="accountablePerson" type="text"
                   maxlength="128" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Telephone number of accountable person from terminal">
            <input [(ngModel)]="exemption.accountablePersonTelephoneNumber" id="accountablePersonTelephoneNumber"
                   type="text"
                   maxlength="128" class="form-control">
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Security level">
            <app-select [(ngModel)]="exemption.securityLevel" id="securityLevel" [options]="securityLevel" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Activity">
            <app-select [(ngModel)]="exemption.activity" id="activity" [options]="activities" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          @if (showDetailedActivityDescription(exemption.activity)) {
            <app-form-group
              label="Detailed description of the work activities (add annexes for extra details if possible at the end of the form)">
              <textarea [(ngModel)]="exemption.activityDescription" id="activityDescription" type="text"
                        rows="3" maxlength="512" class="form-control" required></textarea>
            </app-form-group>
          }
        </div>
        <div class="row">
          <app-form-group label="Access control takes place at the access to :">
            <app-multiselect [(ngModel)]="exemption.accessControl" id="accessControl"
                             (ngModelChange)="resetSecurityMeasuresDescription(exemption.accessControl)"
                             [options]="accessControl" [hideSelected]="true" required>
            </app-multiselect>
          </app-form-group>
        </div>
        <div class="row">
          @if (showSecurityMeasuresDescription(exemption.accessControl)) {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Please describe the security measures</label>
                <div class="tooltipContent">For example, the ship is moored behind the gate on the quay. The gate is
                  locked at all times and can only be opened by the gangway attendant.
                </div>
              </app-info>
              <textarea [(ngModel)]="exemption.securityMeasuresDescription" id="securityMeasuresDescription" type="text"
                        rows="3" maxlength="512" class="form-control" required></textarea>
            </app-form-group>
          }
        </div>
        <div class="row">
          <app-form-group label="How is supervision carried out on the land-side loading and unloading operations ?">
            <textarea [(ngModel)]="exemption.howIsSupervisionCarriedOut" id="howIsSupervisionCarriedOut" type="text"
                      rows="3" maxlength="512" class="form-control" required></textarea>
          </app-form-group>
        </div>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>During the entire mooring period, a gangway watch will be deployed. This is provided by:</label>
              <div class="tooltipContent">The gangway watch ensures identity control of the intended visitor based on
                valid identity documents, verification whether the intended visitor is welcome on board based on the
                visitor list, crew list, etc., and registration of incoming and outgoing visitors.
              </div>
            </app-info>
            <app-select [(ngModel)]="exemption.gangwayWatchProvidedBy" id="gangwayWatchProvidedBy"
                        [options]="gangwayWatchProvidedBy" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="The gangway watch has the crew list ?">
            <app-yes-no [(ngModel)]="exemption.gangwayWatchHasTheCrewList" id="gangwayWatchHasTheCrewList"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="The ship's crew will disembark or embark during the mooring period ?">
            <app-yes-no [(ngModel)]="exemption.shipCrewWillDisembarkOrEmbark"
                        (ngModelChange)="resetEmbarkingSelection()" id="shipCrewWillDisembarkOrEmbark"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          @if (showEmbarkingSelection(exemption.shipCrewWillDisembarkOrEmbark)) {
            <app-form-group label="Embarking selection">
              <app-select [(ngModel)]="exemption.embarkingSelection" id="embarkingSelection" [options]="embarking"
                          required>
              </app-select>
            </app-form-group>
          }
        </div>
        <div class="row">
          <app-form-group label="Is there provisioning at this location ?">
            <app-yes-no [(ngModel)]="exemption.thereIsProvisioning" id="thereIsProvisioning" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>A visitor list for the ship will be prepared (note: visitors are to be avoided as much as
                possible). The visitor list is available with the person in charge at the terminal and with the gangway
                watch.</label>
              <div class="tooltipContent">You must agree in order to request the exemption</div>
            </app-info>
            <input [(ngModel)]="exemption.visitorListPrepared" id="visitorListPrepared" type="checkbox"
                   class="form-check-input" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Unauthorized persons will be kept away from the mooring location.</label>
              <div class="tooltipContent">You must agree in order to request the exemption</div>
            </app-info>
            <input [(ngModel)]="exemption.unauthorizedPersonsKeptAway" id="unauthorizedPersonsKeptAway" type="checkbox"
                   class="form-check-input" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Suspicious circumstances are immediately reported to the person in charge at the terminal. This
                person must inform the Seaport Police (112) and the Port Security Officer (010 252 1000).</label>
              <div class="tooltipContent">You must agree in order to request the exemption</div>
            </app-info>
            <input [(ngModel)]="exemption.suspiciousCircumstancesReported" id="suspiciousCircumstancesReported"
                   type="checkbox" class="form-check-input" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>The undersigned declares to ensure that this equivalent security arrangement will be fully complied
                with during the entire duration of the ship visit.</label>
              <div class="tooltipContent">You must agree in order to request the exemption</div>
            </app-info>
            <input [(ngModel)]="exemption.equivalentSecurityComplied" id="equivalentSecurityComplied" type="checkbox"
                   class="form-check-input" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for ESA</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="512"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
